export default __webpack_public_path__ + "b8cfa686d82a9018861e1c8d293503c1.webp";